import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-3">
            &bull; Product Categories
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Explore Every Shopping <br />Category You Need
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl leading-relaxed">
            From sneakers to accessories, every category is organized with verified sellers, QC photos, and direct links — all ready to explore.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block p-5 md:p-6 bg-background-50 rounded-2xl border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors duration-300 mb-4">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-1.5 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                Explore Category
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}